var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVegvizerLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_2_4",
    "data-name": "Component 2 \\u2013 4",
    xmlns: "http://www.w3.org/2000/svg",
    width: 185.331,
    height: 41.68,
    viewBox: "0 0 185.331 41.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M288.5,752.36v3.033h-7.732v3.4h6.844v3.033h-6.844v3.443H288.8V768.3H277.624V752.36Z",
    transform: "translate(-209.676 -735.036)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M1004.159,752.36V768.3h-3.14V752.36Z",
    transform: "translate(-874.004 -735.036)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M1356.6,752.36v3.033h-7.732v3.4h6.844v3.033h-6.844v3.443h8.036V768.3H1345.73V752.36Z",
    transform: "translate(-1190.129 -735.036)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(137.704 17.496)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M1132.8,766.632h5.308v3.313H1127.67l5.719-12.185h-5.749v-3.313h10.8Z",
    transform: "translate(-1127.639 -754.447)",
    fill: "#fff"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M1571.973,768.306l-3.823-5.694c.093-.051.184-.1.271-.16a4.659,4.659,0,0,0,1.8-2.047,6.52,6.52,0,0,0,.552-2.673,5.021,5.021,0,0,0-1.6-3.932,6.542,6.542,0,0,0-4.527-1.44h-4.829v3.017l3.194,4.823h-.053v-.012h-3.141V768.3h3.141v-5.046h2.075l3.345,5.052Zm-6.768-12.913a2.106,2.106,0,0,1,1.928.789,3.032,3.032,0,0,1,.5,1.637,2.574,2.574,0,0,1-.239,1.038,2.36,2.36,0,0,1-.779.943,1.764,1.764,0,0,1-.249.153l-3.066-4.566Z",
    transform: "translate(-1386.642 -735.036)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M22,752.36l7.276,16.676,7.276-16.676Zm4.985,3.007h4.7l-2.277,5.981Z",
    transform: "translate(24.97 -735.036)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M737.582,752.48l7.276,16.676,7.276-16.676Zm4.985,3.007h4.7l-2.277,5.981Z",
    transform: "translate(-631.888 -735.146)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M493.509,757.3v2.415H496.7v.982a6.855,6.855,0,0,1-1.8,1.517,4.535,4.535,0,0,1-2.266.613,4.134,4.134,0,0,1-1.836-.4,4.664,4.664,0,0,1-1.456-1.106,4.981,4.981,0,0,1-.965-1.644,6.046,6.046,0,0,1-.341-2.067,6.221,6.221,0,0,1,.319-2,5.256,5.256,0,0,1,.911-1.668,4.377,4.377,0,0,1,1.4-1.138,3.859,3.859,0,0,1,1.79-.414,4.54,4.54,0,0,1,2.31.613,4.177,4.177,0,0,1,1.65,1.771l.044.086,2.429-1.792-.032-.062a6.249,6.249,0,0,0-2.427-2.54,7.429,7.429,0,0,0-3.863-.959,7.516,7.516,0,0,0-3.086.631A7.775,7.775,0,0,0,487,751.866a7.94,7.94,0,0,0-1.644,2.555,8.2,8.2,0,0,0-.585,3.095,8.694,8.694,0,0,0,.585,3.217,8.08,8.08,0,0,0,1.632,2.6,7.665,7.665,0,0,0,2.432,1.746,7.019,7.019,0,0,0,2.942.631,6.715,6.715,0,0,0,4.33-1.512v1.4h2.7v-8.3Z",
    transform: "translate(-399.827 -732.411)",
    fill: "#fff"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(-21.582 -19.858)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(2007.583 -80.734) rotate(139)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M1567.745,1328.488l8.573-27.921-26.63,12.225Zm-2.07-6.715-8.752-7.608,12.858-5.7Z",
    transform: "translate(-0.001 -114.664)",
    fill: "#9460f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(1551.081 1181.759)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M1807.23,1505.3l.012.01h0Z",
    transform: "translate(-1798.102 -1492.5)",
    fill: "#69efad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M1596.621,1181.759l-20.123,9.657,5.614,4.845,7.9,6.819,3.845-12.457.018-.009Zm-10.983,12.809h0l-2.7-2.343,7.882-3.968-.9,3.025-1.652,5.439Z",
    transform: "translate(-1576.498 -1181.759)",
    fill: "#69efad"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    x1: 10.275,
    y2: 5.007,
    transform: "translate(1557.371 1194.394)",
    fill: "#9cff95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M1555.175,1497.858l7.68-3.723-1.749-3.833s-8.384,3.731-11.435,5.209",
    transform: "translate(0 -297.417)",
    fill: "#9460f5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVegvizerLogo);
export default __webpack_public_path__ + "static/media/vegvizerLogo.60b80640405b3e5c2bccd6cb0b432565.svg";
export { ForwardRef as ReactComponent };